<template>
  <div :class="{ 'be-room-card__confirm-stack-top': stackOnTop }">
    <b-modal
      v-model="isShown"
      centered
      hide-header
      hide-footer
      static
      modal-class="be-room-card__confirm-modal">
      <div class="be-room-card__confirm text-center p-2">
        <p class="be-room-card__confirm-title">{{ $t(titleKey) }}</p>
        <p class="be-room-card__confirm-desc">{{ $t(descKey) }}</p>
        <div class="be-room-card__confirm-actions">
          <button type="button" class="be-room-card__confirm-cancel" @click="$emit('cancel')">{{ $t(cancelKey) }}</button>
          <button type="button" class="be-room-card__confirm-book" @click="$emit('confirm')">{{ $t(confirmKey) }}</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'RoomCardConfirmModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      titleKey: {
        type: String,
        default: 'hotel.book-now-replace-cart-title'
      },
      descKey: {
        type: String,
        default: 'hotel.book-now-replace-cart-desc'
      },
      cancelKey: {
        type: String,
        default: 'general.cancel'
      },
      confirmKey: {
        type: String,
        default: 'hotel.book-now'
      },
      // opt-in for callers that mount this at page level, outside whatever
      // fixed overlay opened it -- see the stacking note in the style block
      stackOnTop: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isShown: {
        get(){
          return this.value;
        },
        set(isShown){
          this.$emit('input', isShown);
        }
      }
    }
  }
</script>

<style scoped>
/* b-modal wraps dialog + backdrop in an unclassed outer <div> pinned inline at
   `position: absolute; z-index: <base>` (1040). That div is a stacking context,
   so the 1100 below can never lift the dialog past the BE map popup's own
   dim/panel (1041-1043) when this modal is mounted at page level rather than
   inside the popup. Raising this root nests b-modal's whole 1040 context in a
   1100 one, which is the only place the value bites. */
.be-room-card__confirm-stack-top {
  position: relative;
  z-index: 1100;
}
/* static keeps this modal inline in BeRoomCard's DOM now (see the unscoped
   block below), so --be-v3-content-font actually inherits here — kept as an
   explicit fallback in case a future caller ever drops `static` again */
.be-room-card__confirm {
  font-family: var(--be-v3-content-font, BeV3Sans), sans-serif;
}
.be-room-card__confirm-title {
  margin-bottom: 6px;
  font-size: 1.125rem;
  line-height: 1.3;
  font-weight: 600;
}
.be-room-card__confirm-desc {
  margin-bottom: 16px;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #555;
}
.be-room-card__confirm-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}
.be-room-card__confirm-book,
.be-room-card__confirm-cancel {
  border-radius: var(--be-v3-button-radius, 999px);
  padding: 10px 20px;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
}
.be-room-card__confirm-book {
  background: var(--merchant-button-color, var(--merchant-primary-color, #79a33a));
  color: #fff;
  border: none;
}
.be-room-card__confirm-cancel {
  background: #fff;
  color: var(--merchant-primary-color, #79a33a);
  border: 1px solid var(--merchant-primary-color, #79a33a);
}
</style>

<!-- Unscoped on purpose: .modal/.modal-backdrop are rendered by b-modal's own
     internal render function, never passing through this SFC's template, so
     a scoped selector (which relies on a data-v attribute BootstrapVue's own
     markup never gets) can't reach them regardless of the `static` prop.

     `static` (on the <b-modal> above) is what actually matters for stacking:
     without it, b-modal portals straight to <body>, escaping whatever
     stacking context BeMapRoomModal's .be-mapmodal__wrap (z-index 1043) sits
     in -- a z-index set from outside that context isn't reliably compared
     against it (confirmed in devtools: 1100 was applied and still rendered
     behind). `static` keeps the dialog nested inside BeRoomCard's own DOM
     instead, in the same stacking context as whatever popup opened it, so
     the z-index below only has to win locally. Pinned well above this app's
     overlay stack (up to 1046) regardless, since bootstrap's base .modal
     z-index (1050) isn't reliably above it in every browser. -->
<style>
.be-room-card__confirm-modal {
  z-index: 1100 !important;
}
.be-room-card__confirm-modal ~ .modal-backdrop {
  z-index: 1099 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/v3/room-card/RoomCardConfirmModal.vue